import messages from './messages';

const localeRedirects = {
    'gl': 'es',
    'ca': 'es',
    'eu': 'es',
}

export const initReactIntl = () => {

    let locale = (navigator.languages && navigator.languages[0]) ||
        navigator.language || navigator.userLanguage || 'en';
    const localeWithoutRegionCode = locale.toLowerCase().split(/[_-]+/)[0];
    if(localeRedirects[localeWithoutRegionCode] || localeRedirects[locale]) {
        locale = localeRedirects[localeWithoutRegionCode] || localeRedirects[locale];
    }
    const localeMessages = messages[locale] ||
        messages[localeWithoutRegionCode] || messages['en'];

    locale = localeMessages === messages['en'] ? 'en' : locale;

    return {locale, messages: localeMessages};

}
